/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Refresh_Draft_HintInputs */

const vi_einvoice_refresh_draft_hint = /** @type {(inputs: Einvoice_Refresh_Draft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản nháp chưa sẵn sàng phát hành hoặc đã thay đổi. Bấm Cập nhật nháp rồi kiểm tra lại PDF.`)
};

/**

* @param {Einvoice_Refresh_Draft_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_refresh_draft_hint = /** @type {((inputs?: Einvoice_Refresh_Draft_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Refresh_Draft_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_refresh_draft_hint(inputs)
});